import { z } from 'zod';

export enum ChallengeNames {
  SMS = 'SMS_MFA',
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
}

const stringField = (fieldName: string) =>
  z.string({
    required_error: `${fieldName} is required`,
    invalid_type_error: `${fieldName} must be a string`
  });

export const SignInTOSchema = z.object({
  username: stringField('username').optional(),
  merchant: stringField('merchant').optional(),
  userRole: stringField('userRole').optional(),
  signInResult: z
    .object({
      AccessToken: stringField('AccessToken'),
      ExpiresIn: z.number({
        required_error: 'ExpiresIn is required',
        invalid_type_error: 'ExpiresIn must be a number'
      }),
      TokenType: stringField('TokenType'),
      RefreshToken: stringField('RefreshToken'),
      IdToken: stringField('IdToken'),
      challengeName: z.nativeEnum(ChallengeNames),
      session: stringField('session'),
      challengeParameters: z.object({
        userAttributes: stringField('userAttributes'),
        requiredAttributes: stringField('requiredAttributes'),
        CODE_DELIVERY_DESTINATION: stringField('CODE_DELIVERY_DESTINATION'),
        CODE_DELIVERY_DELIVERY_MEDIUM: stringField(
          'CODE_DELIVERY_DELIVERY_MEDIUM'
        )
      })
    })
    .deepPartial()
});

export type SignInTO = ReturnType<typeof SignInTOSchema.parse>;
